/**
 * Returns the base location which indicates the active realm. The default base location is '/*'.
 * */
export function getBaseLocation() {
  const paths: string[] = location.pathname.split('/').splice(1, 1);
  const basePath: string = (paths && paths[0]) || '*';
  return '/' + basePath;
}
